<template>
  <div v-show="isShow" v-if="isExistence">
    <div class="lastsales">
      <img
        class="lastsales-img"
        :alt="this.lastSale.productName"
        :src="this.lastSale.productImage&&this.lastSale.productImage.thumbnail ? this.lastSale.productImage.thumbnail : this.defaultImage"
      />
      <span class="lastsales-product-name">{{this.lastSale.productName}}</span>
      <span class="lastsales-customer-name">{{this.lastSale.customerName}}</span>
      <span class="lastsales-purchased">recently purchased</span>
    </div>
    <div class="app-lastsales">
      <span class="app-lastsales-img iconfont">&#xe604;</span>
      <span class="app-lastsales-customer-name">{{this.lastSale.customerName}} recently purchased</span>
    </div>
  </div>
</template>
<script>
import API from "../../../API";
import defaultImage from "../../../../../public/images/default-Lastsales.png";
export default {
  data() {
    return {
      lastSale: {
        productImage: {
          ID: "",
          url: "",
          thumbnail: "",
          medium: "",
          big: "",
          srcset: "",
        },
        productName: "",
        customerName: "",
      },
      lastSales: [],
      nowLength: 0, //当前播放的购买记录
      changeSale: "",
      isShow: false,
      isExistence: true,
      defaultImage,
    };
  },
  mounted() {
    this.fetchLastSales();
  },
  methods: {
    async fetchLastSales() {
      try {
        let res = await this.$axios.get(API.last_sales);
        this.lastSales = res.data.data;
        if (!this.lastSales.length) {
          return;
        }
        this.lastSale = this.lastSales[this.nowLength];
        this.isShow = true;
        this.changeSale = setInterval(() => {
          this.isShow = false;
          this.lastSale = this.lastSales[++this.nowLength];
          this.isShow = true;
          if (!this.lastSale) {
            this.isShow = false;
            this.isExistence = false;
            clearInterval(this.changeSale);
          }
        }, 10000);
      } catch (error) {
        return;
      }
    },
  },
};
</script>
<style scoped lang="scss">
.lastsales {
  line-height: 1.6;
  width: 240px;
  height: 90px;
  font-size: 13px;
  background-color: rgba(0, 0, 0, 0.7);
  border-radius: 6px;
  position: fixed;
  bottom: 100px;
  animation: showHideContainer 10s;
  animation-iteration-count: 10;
  z-index: 9999;
  // pointer-events: none; //元素不会成为鼠标事件的target，不遮挡下层元素
  text-align: left;
  .lastsales-img {
    height: 88px;
    width: 88px;
    border-radius: 6px 0 0 6px;
    margin: 1px 10px 1px 1px;
    float: left;
    animation: showHideContent 10s;
    animation-iteration-count: 10;
  }
  .lastsales-product-name {
    color: white;
    width: 130px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    position: absolute;
    top: 5px;
    animation: showHideContent 10s;
    animation-iteration-count: 10;
  }
  .lastsales-customer-name {
    color: white;
    width: 130px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    position: absolute;
    bottom: 25px;
    animation: showHideContent 10s;
    animation-iteration-count: 10;
  }
  .lastsales-purchased {
    color: white;
    position: absolute;
    bottom: 5px;
    animation: showHideContent 10s;
    animation-iteration-count: 10;
  }
}

.app-lastsales {
  line-height: 1.6;
  width: 240px;
  height: 30px;
  font-size: 13px;
  background-color: rgba(0, 0, 0, 0.7);
  border-radius: 6px;
  position: fixed;
  top: 80px;
  left: 20px;
  animation: showHideContainerApp 10s;
  animation-iteration-count: 10;
  z-index: 9999;
  pointer-events: none; //元素不会成为鼠标事件的target，不遮挡下层元素
  text-align: left;
  .app-lastsales-img {
    margin-right: 10px;
    margin-left: 10px;
    color: orange;
    animation: showHideContentApp 10s;
    animation-iteration-count: 10;
    font-size: 20px;
  }

  .app-lastsales-customer-name {
    color: white;
    width: 190px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    position: absolute;
    top: 5px;
    animation: showHideContentApp 10s;
    animation-iteration-count: 10;
  }
}

@keyframes showHideContainer {
  0% {
    left: -400px;
    background-color: rgba(0, 0, 0, 0);
  }
  10% {
    left: 10px;
    background-color: rgba(0, 0, 0, 0.7);
  }
  20% {
    left: 10px;
    background-color: rgba(0, 0, 0, 0.7);
  }
  80% {
    left: 10px;
    background-color: rgba(0, 0, 0, 0.7);
  }
  85% {
    left: 10px;
    background-color: rgba(0, 0, 0, 0);
  }
  100% {
    left: 10px;
    background-color: rgba(0, 0, 0, 0);
  }
}

@keyframes showHideContent {
  0% {
    opacity: 0;
    visibility: hidden;
  }
  10% {
    opacity: 1;
    visibility: visible;
  }
  80% {
    opacity: 1;
    visibility: visible;
  }
  85% {
    opacity: 0;
    visibility: hidden;
  }
  100% {
    opacity: 0;
    visibility: hidden;
  }
}

@keyframes showHideContainerApp {
  0% {
    background-color: rgba(0, 0, 0, 0);
  }
  10% {
    background-color: rgba(0, 0, 0, 0.7);
  }
  40% {
    background-color: rgba(0, 0, 0, 0.7);
  }
  45% {
    background-color: rgba(0, 0, 0, 0);
  }
  100% {
    background-color: rgba(0, 0, 0, 0);
  }
}

@keyframes showHideContentApp {
  0% {
    opacity: 0;
    visibility: hidden;
  }
  10% {
    opacity: 1;
    visibility: visible;
  }
  40% {
    opacity: 1;
    visibility: visible;
  }
  45% {
    opacity: 0;
    visibility: hidden;
  }
  100% {
    opacity: 0;
    visibility: hidden;
  }
}

@media screen and (max-width: 575px) {
  .lastsales {
    display: none;
  }
}

@media screen and (min-width: 575px) {
  .app-lastsales {
    display: none;
  }
}
</style>
